import { useEffect } from 'react';

const defaultOptions = {
  attributes: true,
  childList: true,
  subtree: true
};
const useMutationObserver = function (ref, callback) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultOptions;
  useEffect(() => {
    if (ref.current) {
      const observer = new MutationObserver(callback);
      observer.observe(ref.current, options);
      return () => {
        observer.disconnect();
      };
    }
  }, [callback, options]);
};

export { useMutationObserver as default };
